export enum AddToolViewMode {
  GENERAL,
  STATUS,
  CAVITIES,
  SETUP,
  MATCHING_CRITERIA,
  PRODUCTS
}
